import { styled } from '@mui/material/styles';
const PREFIX = 'Sidebar';
export const classes = {
    root: `${PREFIX}-root`,
    listContainer: `${PREFIX}-listContainer`,
    container: `${PREFIX}-container`,
    containerExpand: `${PREFIX}-containerExpand`,
    containerCollapse: `${PREFIX}-containerCollapse`,
    expandContainer: `${PREFIX}-expandContainer`,
    expandDivider: `${PREFIX}-expandDivider`,
    expandToggle: `${PREFIX}-expandToggle`,
    listDivider: `${PREFIX}-listDivider`,
};
const Root = styled('nav')(({ theme }) => ({
    [`&.${classes.root}`]: {
        display: 'flex',
        marginLeft: theme.spacing(2),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        backgroundColor: theme.palette.background.paper,
        [`&:hover .${classes.expandDivider}`]: {
            backgroundColor: theme.palette.primary.light,
            opacity: 1,
        },
        [`&:hover .${classes.expandToggle}`]: {
            opacity: 1,
        },
    },
    [`& .${classes.listContainer}`]: {
        flexGrow: 1,
    },
    [`& .${classes.container}`]: {
        display: 'flex',
        flexDirection: 'column',
        zIndex: 2,
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    [`& .${classes.containerExpand}`]: {
        width: 200,
    },
    [`& .${classes.containerCollapse}`]: {
        width: 56,
    },
    [`& .${classes.expandContainer}`]: {
        margin: theme.spacing(2),
        marginLeft: 0,
        zIndex: 1,
        flexGrow: 1,
        display: 'flex',
        justifyContent: 'center',
        position: 'relative',
        cursor: 'pointer',
    },
    [`& .${classes.expandDivider}`]: {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
    },
    [`& .${classes.expandToggle}`]: {
        position: 'absolute',
        cursor: 'pointer',
        opacity: 0,
        width: 24,
        height: 24,
        marginTop: theme.spacing(4) + 3,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        border: `1px solid ${theme.palette.primary.main}`,
        borderRadius: 24,
        backgroundColor: theme.palette.background.paper,
        '& > svg': {
            width: 24,
            height: 24,
            color: theme.palette.primary.main,
        },
        '&:hover': {
            backgroundColor: theme.palette.primary.main,
            '& > svg': {
                color: theme.palette.background.paper,
            },
        },
    },
    [`& .${classes.listDivider}`]: {
        margin: theme.spacing(1),
    },
}));
export default Root;
//# sourceMappingURL=styled.js.map